import { render } from "./IconRal.vue?vue&type=template&id=dd662c34&scoped=true"
const script = {}

import "./IconRal.vue?vue&type=style&index=0&id=dd662c34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd662c34"]])

export default __exports__